import {components} from "react-select";
import React from "react";
import Checkbox from "./Checkbox";
import classes from 'classnames';

const Option = props => {

    const onCheckChange = ({checked}) => {
        var data = {
            ...props.data,
            checked
        }
        if(props.selectProps.onCheckChange)
            props.selectProps.onCheckChange(data);
    }

    const selectedClass = props.data.checked ? "selected" : null;

    return (
        <components.Option {...props} className={ classes(selectedClass) }>
            <div className="option-wrapper">
                <Checkbox onCheckChange={onCheckChange} accessKey={props.data.key} checked={props.data.checked} disabled={props.data.value != 'all' && props.selectProps.isAllChecked ? true : false}></Checkbox>
                {props.label}
            </div>
        </components.Option>
    );
};

export default Option;